import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Loading, WideCardFilter } from '../Main'
import ReturnTable from '../../containers/return/ReturnTable'

const WideCardReturn = (data) => {
  const { loading, payload, download, pagination, onPageChange, onLimitChange } = data
  const { t } = useTranslation()

  const [payloadFilter, setPayloadFilter] = useState(payload)
  const [loadingRequest] = useState(false)
  const filter = {
    text_search: true,
    status: {
      multiple: true,
      options: [
        { value: 'REQUEST', label: t(`status.bill.WAITING_APPROVAL`) },
        { value: 'APPROVED', label: t(`status.bill.APPROVED`) },
        { value: 'CANCELLED', label: t(`status.bill.CANCELLED`) },
        { value: 'REJECTED', label: t(`status.bill.REJECTED`) },
      ],
    },
    download: download,
  }

  const handleFilter = (row) => {
    let objPayload = { ...payloadFilter }
    objPayload.page = 1
    objPayload.keywords.text_search = row?.keywords.text_search
    objPayload.keywords.status = row?.keywords.status
    data.handleFilter(objPayload)
    setPayloadFilter(objPayload)
  }

  return (
    <>
      {/* FILTER */}
      <WideCardFilter
        buttonCheckSaldo
        filter={filter}
        payload={payload}
        handleFilter={handleFilter}
        label_input={t('placeholder.return_filter')}
      />
      {loading || loadingRequest ? (
        <div className="d-flex justify-content-center">
          <Loading />
        </div>
      ) : (
        <>
          <div>
            <div className="border border-width-2 border-color-3 borders-radius-6 container wide-card rounded mb-5">
              <div className="row">
                <div className="col-12">
                  <ReturnTable
                    data={data}
                    pagination={pagination}
                    onPageChange={onPageChange}
                    onLimitChange={onLimitChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default WideCardReturn
